import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'
import Image from 'next/image'
import {Container} from 'src/common/Container'
import {Source} from 'src/common/SourceSet'
import {ComparisonTableBody, ComparisonTableHead} from './components/Table'

type DefaultComparisonSectionProps = {
  slice: Content.ComparisonSectionSliceDefault
}

export const DefaultComparisonSection = ({slice}: DefaultComparisonSectionProps) => (
  <Container
    backgroundColor={slice.primary.background_color}
    data-slice-type="comparison_section"
    data-slice-variation="default"
    className="overflow-visible px-5 md:max-lg:px-10"
  >
    <div className="flex w-full flex-col gap-12 md:gap-4 lg:flex-row xl:max-w-[1200px]">
      <div
        className={cn('order-2 w-full overflow-visible rounded-xl pb-4 md:rounded-2xl lg:order-1', {
          'bg-beige-200':
            slice.primary.background_color === 'Moss White' || !isFilled.select(slice.primary.background_color),
          'bg-moss-white':
            slice.primary.background_color === 'Beige/200' || slice.primary.background_color === 'Grey/100',
        })}
      >
        <div className="w-full border-0">
          <ComparisonTableHead
            comparisonProducts={slice.primary.comparison_products}
            backgroundColor={slice.primary.background_color}
          />
          <ComparisonTableBody
            tableBody={slice.primary.table}
            backgroundColor={slice.primary.background_color}
            contentCenter={slice.primary.centralise_table_content}
            enableReskin={slice.primary.enable_reskin}
          />
        </div>
      </div>
      <div
        className={cn(
          'order-1 flex w-full flex-col items-center justify-between rounded-lg pt-[30px] md:pt-10 md:max-lg:hidden lg:order-2 lg:max-w-[328px] lg:overflow-hidden',
          {
            'bg-green-dark':
              slice.primary.banner_section[0]?.background === 'Dark green' ||
              !isFilled.select(slice.primary.banner_section[0]?.background),
            'bg-gradient-to-br from-[#021D07] to-[#083811]':
              slice.primary.banner_section[0]?.background === 'Dark green gradient',
          },
        )}
      >
        <h4 className="text-h4 px-[30px] text-center text-[32px] font-medium leading-10 text-moss-white md:px-10 md:text-start">
          {slice.primary.banner_section[0]?.title}
        </h4>
        {isFilled.image(slice.primary.banner_section[0]?.image) &&
        isFilled.image(slice.primary.banner_section[0]?.mobile_image) ? (
          <picture className="mt-[30px]">
            <Source src={slice.primary.banner_section[0]?.mobile_image.url || ''} media="(max-width: 680px)" />
            <Image
              className="mx-auto"
              src={slice.primary.banner_section[0]?.image.url!}
              alt=""
              width={1200}
              height={500}
              priority
            />
          </picture>
        ) : (
          <PrismicNextImage
            field={slice.primary.banner_section[0]?.image}
            className="mt-[30px] w-full max-w-[290px] md:max-w-full"
          />
        )}
      </div>
    </div>
  </Container>
)
